import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';

import { chatRoutePercentage } from 'globals/styles';

import AppAPI from '../../../../api';
import ChatConversationHeader from '../ChatConversationHeader';
import ChatConversationInput from '../ChatConversationInput';
import ChatConversationVolumeControlInput from '../ChatConversationVolumeControlInput';
import ChatConversationThread from '../ChatConversationThread';
import ChatConversationDescribe from '../describe/ChatConversationDescribe';
import ChatAppOfflineWarning from '../../app/ChatAppOfflineWarning';

import * as chatActions from '../../app/ChatApp/actions';
import * as appActions from '../../../app/App/actions';
import * as chatSelectors from '../../app/ChatApp/selectors';
import ChatConversationQueuePoller from '../ChatConversationQueuePoller';

export class ChatConversation extends PureComponent {
  componentDidMount() {
    const { sessionId } = this.props;
    if (sessionId) {
      AppAPI.subscribeToChatActivityChannel();
      AppAPI.subscribeToCustomerPresenceChannel();
    }
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { sessionId } = this.props;
    const nextPropsSessionId = get(nextProps, 'sessionId');

    if (sessionId && nextPropsSessionId !== sessionId) {
      AppAPI.subscribeToChatActivityChannel();
      AppAPI.subscribeToCustomerPresenceChannel();
    }
  }
  componentWillUnmount() {
    AppAPI.unsubscribeFromChatActivityChannel();
  }
  renderInputForState() {
    const { isVolumeControl } = this.props;

    if (isVolumeControl) {
      return <ChatConversationVolumeControlInput />;
    }

    return <ChatConversationInput />;
  }

  render() {
    const { handleClose, hasAgent, sessionId, isVolumeControl } = this.props;

    if (!sessionId) {
      return null;
    }

    return (
      <div style={{ height: `${chatRoutePercentage}%`, display: 'flex', flexDirection: 'column' }}>
        <ChatConversationQueuePoller />
        <ChatConversationHeader onCloseClick={handleClose} expanded={sessionId === 'new'} hasAgent={hasAgent} />
        <ChatConversationDescribe />
        <ChatConversationThread isVolumeControl={isVolumeControl} />
        <ChatAppOfflineWarning />
        {this.renderInputForState()}
      </div>
    );
  }
}

ChatConversation.propTypes = {
  sessionId: PropTypes.string,
  handleClose: PropTypes.func,
  hasAgent: PropTypes.bool,
  isVolumeControl: PropTypes.bool,
};

ChatConversation.defaultProps = {
  sessionId: null,
  handleClose: () => {},
  hasAgent: false,
  isVolumeControl: false,
  isLocked: false,
};

export const mapStateToProps = (state, ownProps) => {
  return {
    sessionId: chatSelectors.getActiveSessionId(state),
    hasAgent: chatSelectors.hasAgentInActiveSessionMessages(state),
    isVolumeControl: chatSelectors.getActiveSessionIsInVolumeControl(state, ownProps),
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    handleClose() {
      dispatch(appActions.handleCloseApp());
    },
    handleThreadScroll() {
      dispatch(chatActions.handleChatFetchNextMessagesForActiveSession());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChatConversation);
